import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { Size, LogGroup, Scale, Point, CreateElement } from "../.././MyHelpers";
import { ISpinnableReels } from "../SpinAnimation/SpinnableReels";
import { GenericPlusOne, PlusOneParams } from "./GenericPlusOneAnimation";
import { SpriteResource } from "../../ResourceManager/SpriteResource";
import { CanvasSprite } from "../Sprite/CanvasSprite";
import { Sprite } from "../Sprite/Sprite";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, ResourceManager } from "../../ResourceManager/ResourceManager";
import { TimelineLite , TimelineMax ,  TweenMax , Power0 } from "gsap";
import { TimelineMaxEx } from "../TimelineLiteWithAddDelay";
import { RenderTexturePool } from "pixi.js";


export interface PlusOnePosition {
	Reel: number;
	Row: number;
}

export type SpritePlusOneComplete = (index: number) => void;
export class FreegameSpritePlusOneElement {
	protected index: number;
	protected view: HTMLElement;
	protected spr: SpriteResource;
	protected symbolSize: Size;
	protected sprSprite: Sprite;
	protected sprcanvas: CanvasSprite;



	protected startPosition: Point = null;
	protected endPosition: Point = null;
	//public commonResourcesBasePath: string;

	protected anim: TimelineMaxEx = null;

	public constructor(index: number, spr: SpriteResource, symbolSize: Size) {
		this.index = index;
		this.spr = spr;
		this.sprSprite = spr.sprite;
		this.symbolSize = symbolSize;
		this.sprcanvas = new CanvasSprite({ sprite: this.sprSprite, canvasSize: new Size(Scale.W(300), Scale.H(250)) });
		this.sprcanvas.Start(true);


		this.view = document.createElement("div");
		this.view.classList.add("PlusOne-" + index);
		this.view.style.boxSizing = "border-box";
		this.view.appendChild(this.sprcanvas.View());
		//this.sprcanvas.Update();


		// set size
		this.view.style.position = "absolute";
		this.view.style.top = "0px";
		this.view.style.left = "0px";
		this.view.style.width = this.symbolSize.Width + "px";
		this.view.style.height = this.symbolSize.Height + "px";
		this.view.style.visibility = "hidden"; // hidden by default
	}


	public SetPosition(startPosition: Point, endPosition: Point): void {
		this.startPosition = startPosition;
		this.endPosition = endPosition;

		this.anim = new TimelineMaxEx({ paused: true, onComplete: () => this.Complete() });
		this.anim.add(TweenMax.fromTo(this.view, 0.5,
			{ visibility: "visible", opacity: 0.2, scale: 0.5, rotation: 0 },
			{ opacity: 1, scale: 1, rotation: 2 * 360 }
		));
		//This its not working its missing in libraries.
		this.anim.addDelay(0.5);

		// use timeline instead of tweenlite, for animating x and y separately
		let a = new TimelineLite();
		a.fromTo(this.view, 0.5,
			{ x: this.startPosition.x - (this.symbolSize.Width / 2) },
			{ x: this.endPosition.x - (this.symbolSize.Width / 2), ease: Power0.easeNone }
		);

		a.fromTo(this.view, 0.5,
			{ y: this.startPosition.y - (this.symbolSize.Height / 2) },
			{ y: this.endPosition.y - (this.symbolSize.Height / 2), ease: Power0.easeNone },
			0
		);

		this.anim.add(a);
	}

	public View(): HTMLElement {
		return this.view;
	}

	public Start() {
		this.view.style.visibility = "visible";
		this.anim.restart();
	}

	protected onCompleteCallback: SpritePlusOneComplete = null;
	public OnComplete(callback: SpritePlusOneComplete): void {
		this.onCompleteCallback = callback;
	}

	protected Complete(): void {
		this.view.style.visibility = "hidden";

		if (this.onCompleteCallback != null) {
			this.onCompleteCallback(this.index);
		}
	}
	public Update() {
		this.sprcanvas.Update();
	}
}


export type FreegameSpritePlusOneComplete = () => void;
export class FreegameSpritePlusOne extends GenericPlusOne {

	/** size of the whole screen. This animation will use whole screen, because it must go to the top edge */
	protected viewSize: Size;

	/** for location of symbols on reels */
	protected spinnableReels: ISpinnableReels;

	/** image to draw as an +1 element, when it animates */
	protected spr: SpriteResource;

	/** size of single symbol in reel, to center the +1 over it */
	protected symbolSize: Size;

	/** container view element */
	protected view: HTMLElement;

	/** all available element to animate. We don't delete those, they act as cache and stay created forever */
	protected elements: FreegameSpritePlusOneElement[] = [];

	/** last set of symbols that triggered +1 */
	protected symbols: PlusOnePosition[] = null;

	/** number of element animations that completed since last start. Used for detecting when all animations have finished */
	protected animationsComplete: number = 0;

	protected duration: number = 1500;
	protected logGroup: LogGroup;
	protected sprCanvas: CanvasSprite;
	protected resid: ResourceIdentifier;
	protected bonusName: string;
	protected countFreeGames: number = 0;
	protected maxAdditionalFreegames: number = 0;


	public constructor(params: PlusOneParams) {
		super();

		this.viewSize = params.viewSize;
		this.spinnableReels = params.spinnableReels;
		this.logGroup = params.logGroup.Add("SpritePlusOne");
		this.resid = params.resid;
		//this.spr = spr;
		this.bonusName = params.bonusName;

		this.symbolSize = params.spinnableReels.GetSymbolSize();

		this.view = CreateElement("div", {
			classes: ["FreegamePlusOne", "SpritePlusOne"], style: {
				position: "absolute",
				top: "0px",
				left: "0px",
				width: this.viewSize.Width + "px",
				height: this.viewSize.Height + "px",
				pointerEvents: "none",
			}
		});
		this.maxAdditionalFreegames = params.maxAdditionalFreegames;
	}

	public Name(): String {
		return "SpritePlusOne";
	}


	 public PrepareResources(resourceManager: IWriteOnlyResourceManager)
	 {
		resourceManager.AddGlobal(new SpriteResource(this.commonResourcesBasePath + this.bonusName+"/resources/plusonespr", ResourceIdentifier.Global.Add("plusonespr").Add(this.bonusName), true, this.logGroup.Add("plusonespr"), true));
	 }
	 public ResourcesLoaded(resourceManager: IReadOnlyResourceManager)
	 {
		 this.spr = resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("plusonespr").Add(this.bonusName));
	 }


	public IsPending(): boolean {
		return true;
	}

	protected jumpAnim: boolean = false;
	/** just starts the animation */
	public Start(symbols: PlusOnePosition[], target: Point): void {
		this.animationsComplete = 0;

		this.symbols = symbols;


		// precreate elements
		if (this.elements.length < symbols.length) {
			for (let i = this.elements.length; i < symbols.length; i++) {
				let plus: FreegameSpritePlusOneElement = new FreegameSpritePlusOneElement(i, this.spr, this.symbolSize);
				this.elements.push(plus);
				this.view.appendChild(plus.View());
			}
		}

		//this.countFreeGames = 0;		

		for (let i = 0; i < symbols.length; i++) {

			//this.spinnableReels.GetSymbolRect()
			// TODO get coordinates from spinnable reels instead of calculating here??
			// let startPoint: Point = new Point(
			// 	this.spinnableReels.GetWindowRect().x + ((symbols[i].Reel + 0.5) * this.symbolSize.width), 
			// 	this.spinnableReels.GetWindowRect().y +((symbols[i].Row + 0.5) * this.symbolSize.height)
			//  );
			this.countFreeGames++;
			if (this.countFreeGames <= this.maxAdditionalFreegames) {
				let startPoint = this.spinnableReels.GetAbsoluteSymbolRectReelRow(symbols[i].Reel, symbols[i].Row).Center();

				this.elements[i].SetPosition(startPoint, target);
				this.elements[i].Start();
				console.log("CountPlusone:", this.countFreeGames);
			}
			else {
				//this.jumpAnim = true;
				console.log("CountPlusoneJump:", true);
				//break
			}
		}
		//this.countFreeGames = 0;

		// finaly start animations
		
			for (let i = 0; i < symbols.length; i++) {				
				//if (i <= this.maxAdditionalFreegames)
				
			}
	}

	public Duration(): number {
		return this.duration;
	}

	/** single element has finished its animation */
	protected ElementComplete(index: number): void {
		this.animationsComplete++;

		// when all elements are finished, the whole animation is finished
		if (this.animationsComplete == this.symbols.length) {
			this.Complete();
		}
	}

	/** returns view element */
	public View(): HTMLElement {
		return this.view;
	}

	protected completeCallback: FreegameSpritePlusOneComplete = null;

	/** set callback for when all elements are complete with animation */
	public OnComplete(callback: FreegameSpritePlusOneComplete): void {
		this.completeCallback = callback;
	}

	/** called when all elements are complete with animation */
	protected Complete(): void {
		if (this.completeCallback != null) {
			this.completeCallback();
		}
	}
	public Update() {
		this.elements.forEach(element => {
			element.Update();
		})
	}
	public ResetCount(){
		this.countFreeGames = 0;
		//this.jumpAnim = false;
	}

	public WillStartAnim() : boolean{
		if (this.countFreeGames < this.maxAdditionalFreegames) {
			return true 
		}
		else {
			return false 
		}
		//return this.jumpAnim;
	}
}
